import React from 'react';
import './Navbar.scss';

type Props = {
  onClick: () => void;
  isActive: boolean;
};

export const Hamburger: React.FC<Props> = ({ onClick, isActive }) => {
  return (
    <div className="mobile-only">
      <button
        style={{
          height: '100%',
          width: 40,
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'inherit',
          border: 'none',
        }}
        onClick={onClick}
      >
        {isActive ? (
          <>
            <div className="hamburger">
              <span className="hamburger-cross" />
              <span className="hamburger-cross" />
            </div>
            <span className="visually-hidden">Close navigation menu</span>
          </>
        ) : (
          <>
            <div className="hamburger">
              <span className="hamburger-burger" />
              <span className="hamburger-burger" />
              <span className="hamburger-burger" />
            </div>
            <span className="visually-hidden">Open navigation menu</span>
          </>
        )}
      </button>
    </div>
  );
};
